module.exports = __webpack_public_path__ + "img/sprites_15.6b6d440f.png";